import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Apps, ToDoHeading } from "../../../Constants/Constants";
import TodoBody from "./TodoBody/TodoBody";
import TodoSidebar from "./TodoSideber/TodoSidebar";

const TodoContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={ToDoHeading} parent={Apps} />
      <Container fluid className="email-wrap bookmark-wrap todo-wrap">
        <Row>
          <TodoSidebar />
          <TodoBody />
        </Row>
      </Container>
    </>
  );
};

export default TodoContainer;
